export default __webpack_public_path__ + "static/media/arrow-left-circle-line.1db8c402.svg";